import { render, staticRenderFns } from "./ui-settings.vue?vue&type=template&id=4f659e7a&"
import script from "./ui-settings.vue?vue&type=script&lang=js&"
export * from "./ui-settings.vue?vue&type=script&lang=js&"
import style0 from "./ui-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f659e7a')) {
      api.createRecord('4f659e7a', component.options)
    } else {
      api.reload('4f659e7a', component.options)
    }
    module.hot.accept("./ui-settings.vue?vue&type=template&id=4f659e7a&", function () {
      api.rerender('4f659e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/ui-settings.vue"
export default component.exports